import React from 'react'
import { Field, reduxForm } from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import { FormButtons, renderers, validations } from '../../components'

let EmailForm = ({ handleSubmit, pristine, reset, submitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs={12}>
          <Field
            label="Email"
            name="email"
            validate={[validations.required]}
            component={renderers.renderField}
            type="email"
          />
        </ReactBootstrap.Col>

        <ReactBootstrap.Col md={12} xs={12} lg={12}>
          <FormButtons
            submitting={submitting}
            pristine={pristine}
            reset={reset}
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </form>
  )
}
EmailForm = reduxForm({
  form: 'send-log-form',
})(EmailForm)

export default EmailForm
